import { NgModule } from "@angular/core"
import { Routes, RouterModule } from "@angular/router"
import { PageNotFoundComponent } from "src/app/layout/pages/page-not-found/page-not-found.component"
import { CarrierPromotionsComponent } from "./carrier-promotions/carrier-promotions.component"
import { EditPromotionsComponent } from "./manage-promocode/edit-promotions/edit-promotions.component"
import { EditLoyaltyRewardsComponent } from "./manage-promocode/edit-loyalty-rewards/edit-loyalty-rewards.component"
import { LoyaltyPromocodeSmartComponent } from "./loyalty-rewards/loyalty-promocode-configuration/loyalty-promocode-configuration-smart.component"
import { LoyaltyRewardsConfigurationSmartComponent } from "./loyalty-rewards/loyalty-rewards-configuration/loyalty-rewards-configuration-smart.component"
import { LoyaltyRewardsComponent } from "./loyalty-rewards/loyalty-rewards.component"
import { PromoCodeHistoryComponent } from "./manage-promocode/promo-code-history/promo-code-history.component"
import { ReceivedPromoComponent } from "./manage-promocode/received-promo/received-promo.component"
import { FestivalPromotionsSmartComponent } from "./occasion-rewards/festival-promotions/festival-promotions-smart.component"
import { OccasionRewardsComponent } from "./occasion-rewards/occasion-rewards.component"
import { PromotionsComponent } from "./promotions.component"
import { SendPromoComponent } from "./manage-promocode/send-promo/send-promo.component"
import { SendPromoSmartComponent } from "./manage-promocode/send-promo/send-promo-smart.component"
import { GeneratePromoSuccessComponent } from "./promocode-actions/generate-promo-success/generate-promo-success.component"
import { AssignPromotionsComponent } from "./carrier-promotions/assign-promotions/assign-promotions.component"
import { AssignPromotionsSmartComponent } from "./carrier-promotions/assign-promotions/assign-promotions-smart.component"
import { NewPromotionComponent } from './carrier-promotions/new-promotion/new-promotion.component';
import { NewPromotionSmartComponent } from './carrier-promotions/new-promotion/new-promotion-smart.component';
import { CreateFestivalComponent } from "./occasion-rewards/create-festival/create-festival.component"
import { UpdateFestivalComponent } from "./occasion-rewards/update-festival/update-festival.component"
import { BannerConfigurationComponent } from "./banner-configuration/banner-configuration.component"
import { RetailerBannerComponent } from "./retailer-banner/retailer-banner.component"
import { EditBannerComponent } from "./banner-configuration/edit-banner/edit-banner.component"
import { ManageBannerComponent } from "./banner-configuration/manage-banner/manage-banner.component"
import { AddBannerComponent } from "./banner-configuration/add-banner/add-banner.component"
import { VideoConfigComponent } from "./video-config/video-config.component"
import { AddpromotionComponent } from "./video-config/addpromotion/addpromotion.component"
import { EditVideosComponent } from "./video-config/edit-videos/edit-videos.component"
import { PromoCodeImportComponent } from "./occasion-rewards/promo-code-import/promo-code-import.component"
const promotionsRoutes: Routes = [
  {
    path: "carrier-promotions",
    component: CarrierPromotionsComponent,
  },
  {
    path: 'map-carrier-promotion',
    component: AssignPromotionsComponent
  },
  {
    path: 'map-carrier-promotion/:id',
    component: AssignPromotionsSmartComponent
  },
  {
    path: 'create-carrier-promotion',
    component: NewPromotionSmartComponent
  },
  {
    path: "ocassion-rewards",
    component: OccasionRewardsComponent,
    children: [
      {
        path: "festival-promo",
        component: FestivalPromotionsSmartComponent,
      },
      {
        path: "create-festival",
        component: CreateFestivalComponent,
      },
      {
        path: "update-festival/:id",
        component: UpdateFestivalComponent,
      },
      {
        path: "promo-history",
        component: PromoCodeHistoryComponent,
      },
      {
        path: 'import-promo-code', component: PromoCodeImportComponent
      },
      {
        path: '',
        redirectTo: 'festival-promo',
        pathMatch: 'full'
      }
    ],
  },
  {
    path: "loyalty-config",
    component: LoyaltyRewardsComponent,
    children: [
      {
        path: "rewards",
        component: LoyaltyRewardsConfigurationSmartComponent,
      },
      {
        path: 'promocodes',
        component: LoyaltyPromocodeSmartComponent
      },
      {
        path: '',
        redirectTo: 'rewards',
        pathMatch: 'full'
      }
    ],
  },
  {
    path: "banner-config",
    component: BannerConfigurationComponent,
    children: [
      {
        path: "manage-banner",
        component: ManageBannerComponent,
      },
      {
        path: "edit-banner/:id",
        component: EditBannerComponent,
      },
      {
        path: "add-banner",
        component: AddBannerComponent,
      },
       {
        path: '',
        redirectTo: 'manage-banner',
        pathMatch: 'full'
      }
    ],
  },
  {
    path: "retailer-banner",
    component: RetailerBannerComponent,
  },
  {
    path: 'video-config', component: VideoConfigComponent,

  },
  {
    path: 'video-config/add-videos', component: AddpromotionComponent
  },
  {
    path: 'video-config/edit-videos/:id', component: EditVideosComponent
  },

  {
    path: "manage-promo",
    children: [
      {
        path: "received-promo/:id",
        component: ReceivedPromoComponent,
      },
      {
        path: 'send-promocode',
        component: SendPromoSmartComponent
      },
      {
        path: "edit-promotion/:id",
        component: EditPromotionsComponent,
      },
      {
        path: "edit-promotion",
        component: EditPromotionsComponent,
      },
      {
        path: "edit-loyality",
        component: EditLoyaltyRewardsComponent,
      },
      {
        path: "promo-history",
        component: PromoCodeHistoryComponent,
      },
      {
        path: 'generate-success',
        component: GeneratePromoSuccessComponent
      }
    ],
  },
  {
    path: '',
    redirectTo: 'carrier-promotions',
    pathMatch: 'full'
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(promotionsRoutes)],
  exports: [RouterModule],
})
export class PromotionsRoutingModule { }
